import { NewUserFormValues } from 'types/state';

export const createNewUserFormValues = (): NewUserFormValues => ({
  login: '',
  password: '',
  passwordConfirm: '',
  phoneNumber: 'null'
});
